import React from 'react'
import PropTypes from 'prop-types'

import {
  // Empty, Skeleton,
  message
} from 'antd'

// import BucketDetailHeading from './BucketDetailHeading'
import BucketDetailList from './BucketDetailList'
import AddBucketModal from '../feedback/AddBucketModal'
import ConfirmModal from '../feedback/ConfirmModal'
import PublishBucketModal from '../feedback/PublishBucketModal'
import AuthService from '../../../services/AuthService'

import userMessages from '../../../constants/messages'

import { graphql, withApollo } from '@apollo/client/react/hoc'
import _, { flowRight as compose, isEmpty } from 'lodash'
// import QueryGetBucketDetails from '../../../graphQL/bucket/getBucketDetails'
import QueryGetBucketUpdatedDetails from '../../../graphQL/bucket/getBucketUpdatedDetails'
import MutationCreateBucketItem from '../../../graphQL/bucket/createBucketItem'
import MutationUpdateBucket from '../../../graphQL/bucket/updateBucket'
// import MutationSaveAllBuckets from '../../../graphQL/bucket/saveAllBuckets'
import SubscriptionSaveAllBucket from '../../../graphQL/bucket/saveAllBucketsSubscription'
import MutationUpdateBucketItem from '../../../graphQL/bucket/batchUpdateBucketItem'
import { utilityService } from '../../../services/UtilityService'
// import getUuid from 'uuid-by-string'
// import moment from 'moment'
// import {
//   // multiDragAwareReorder,
//   multiSelect
// } from './utils'
import BucketVersionHeading from './BucketVersionHeading'
import {
  VERSION_DRAGGABLE_ID
  // VERSION_DROPPABLE_ID
} from 'constants/general-constants'

const parent = 'bucket-details-container'
let userSessionId = null

// const reorder = (list, startIndex, endIndex) => {
//   const result = Array.from(list)
//   const [removed] = result.splice(startIndex, 1)
//   result.splice(endIndex, 0, removed)
//   return result
// }

const subscribeChangeInBucket = (subscribeToMore, props, retrying = 50) => {
  return subscribeToMore({
    document: SubscriptionSaveAllBucket,
    variables: { id: props.ownProps.bucketId },
    updateQuery: (
      prev,
      {
        subscriptionData: {
          data: { bucketSaved }
        }
      }
    ) => {
      // if (bucketSaved && bucketSaved.isArchived) {
      //   const variables = { id: data.ownProps.bucketId }
      //   const listCacheData = props.ownProps.client.readQuery({ query: QueryGetBucketDetails, variables })
      //   const index = listCacheData.listBucketGroups.items.findIndex(group => group.id === bucketSaved.id)
      //   if (index !== -1) {
      //     props.ownProps.client.writeQuery({
      //       query: QueryGetBucketGroupList,
      //       data: listCacheData,
      //       variables
      //     })
      //   }
      // }
      if (!bucketSaved || prev.getBucket.id !== bucketSaved.id) return prev
      prev.getBucket = bucketSaved
      return prev
    },
    onError: error => {
      if ((error.errorMessage || '').includes('Socket')) {
        setTimeout(() => {
          subscribeChangeInBucket(subscribeToMore, props, retrying * 2)
        }, retrying)
      }
    }
  })
}

const deleteWarningMessage = {
  title: 'Delete Bucket?',
  message: 'Do you want to delete this bucket from bucket group'
}

class BucketDetailCellVersion extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      bucketDetails: _.cloneDeep(props.bucketDetails),
      isSearch: false,
      isEditted: false,
      isSaveEnable: false,
      saveLoading: false,
      addFilterLoading: false,
      isScroll: false,
      isWarningShow: false,
      isModifiedLoading: false,
      updatedBucketItem: [],
      draggingTaskId: null,
      // entities: this.props.loadVersionBucketDetailsTolistData(_.cloneDeep(props.bucketItemsInVersion), props.versionId),
      listData: []
    }
    this.changedBucketItem = []
    // if (props.bucketId && props.isLoading) {
    //   props.changeLoadingBucket(props.bucketId, 'ADD')
    // }
  }

  initiateSubscription = () => {
    if (this.props.subscribeToChangeBucket) {
      // this.props.subscribeToChangeBucket()
    } else {
      setTimeout(() => {
        this.initiateSubscription()
      }, 1500)
    }
  }

  getObjectDiff = (obj1, obj2) => {
    const diff = Object.keys(obj1).reduce((result, key) => {
      if (!obj2.hasOwnProperty(key)) {
        result.push(key)
      } else if (_.isEqual(obj1[key], obj2[key])) {
        const resultKeyIndex = result.indexOf(key)
        result.splice(resultKeyIndex, 1)
      }
      return result
    }, Object.keys(obj2))

    return diff
  }

  isPropsSame = (newProps, oldProps) => {
    if (_.isEqual(newProps, oldProps)) {
      return true
    }
    const isPropDetailsSame =
      _.isEqual(newProps.isForceSave, oldProps.isForceSave) &&
      _.isEqual(newProps.bucketListData, oldProps.bucketListData) &&
      _.isEqual(newProps.bucketDetails, oldProps.bucketDetails) &&
      _.isEqual(newProps.bucketId, oldProps.bucketId) &&
      _.isEqual(newProps.id, oldProps.id) &&
      _.isEqual(newProps.draggable, oldProps.draggable) &&
      _.isEqual(newProps.droppableId, oldProps.droppableId) &&
      _.isEqual(newProps.destinationIndex, oldProps.destinationIndex) &&
      _.isEqual(newProps.sourceIndex, oldProps.sourceIndex) &&
      _.isEqual(newProps.displayTypes, oldProps.displayTypes) &&
      _.isEqual(newProps.isCreateBlocked, oldProps.isCreateBlocked) &&
      _.isEqual(newProps.isUpdateBlocked, oldProps.isUpdateBlocked) &&
      _.isEqual(newProps.isDeleteBlocked, oldProps.isDeleteBlocked)
    return isPropDetailsSame
  }

  getUserDetails = async () => {
    const userDetails = await AuthService.getUserDetails()
    if (userDetails) {
      this.username = userDetails.name || userDetails.email
    }
  }

  getAddFilterStatus = () => {
    let { bucketDetails } = this.state
    let bucketItems = bucketDetails ? _.cloneDeep(bucketDetails.bucketItems) : []
    const filterCount = (bucketItems || []).filter(item => item.type === 'FILTER').length
    return filterCount >= 3
  }

  // onAddSearch = () => {
  //   this.setState({ addFilterLoading: true, isSaveEnable: false })
  //   const { bucketId } = this.props
  //   let { bucketDetails, updatedBucketItem } = this.state
  //   let { bucketItems: bucketItemsData } = bucketDetails
  //   let bucketItems = cloneDeep(bucketItemsData)
  //   bucketItems = bucketItems && bucketItems.length ? bucketItems : []
  //   const tempId = getUuid(bucketId + 'tempId123')
  //   const newData = {
  //     id: tempId,
  //     type: 'FILTER',
  //     bucket: bucketId,
  //     position: bucketItems.length,
  //     filterRule: {
  //       searchKey: null,
  //       filters: [
  //         {
  //           displayName: null,
  //           displayValue: 'isArchived',
  //           fieldName: 'isArchived',
  //           isRequired: null,
  //           name: 'isArchived',
  //           type: 'BOOLEAN',
  //           value: 'false'
  //         },
  //         {
  //           displayName: null,
  //           displayValue: null,
  //           fieldName: 'updatedAt',
  //           isRequired: null,
  //           name: 'Sort',
  //           type: 'SORT',
  //           value: 'desc'
  //         },
  //         {
  //           displayName: 'Limit',
  //           displayValue: null,
  //           fieldName: null,
  //           isRequired: true,
  //           name: 'limit',
  //           type: 'LIMIT',
  //           value: '10'
  //         }
  //       ]
  //     }
  //   }
  //   bucketItems.push(newData)
  //   bucketDetails.bucketItems = bucketItems
  //   this.setState({ bucketDetails, isScroll: true })
  //   const { id, ...rest } = newData
  //   this.props.changeAddSearchStatusStatus(false)
  //   this.props.createBucketItem({ bucketItems: [{ ...rest }] }).then(
  //     response => {
  //       this.props.updateHistory()
  //       this.props.changeAddSearchStatusStatus(true)
  //       updatedBucketItem.push(response.data.batchCreateBucketItem[0].id)
  //       bucketItems[bucketItems.length - 1].id = response.data.batchCreateBucketItem[0].id
  //       bucketDetails.bucketItems = bucketItems
  //       this.setState(
  //         {
  //           bucketDetails,
  //           entities: this.props.loadVersionBucketDetailsTolistData(bucketDetails),
  //           addFilterLoading: false,
  //           updatedBucketItem
  //         },
  //         () => {
  //           // /* DISABLED AUTO SAVE */
  //           // if (bucketDetails.status === 'DRAFT') {
  //           //   this.saveBucket(true)
  //           // } else {
  //           //   this.props.changeBucket(bucketDetails.id, true)
  //           //   this.setState({ isSaveEnable: true })
  //           // }
  //           this.props.changeBucket(bucketDetails.id, true)
  //           this.setState({ isSaveEnable: true })
  //         }
  //       )
  //     },
  //     error => {
  //       // this.setState({ isSaveEnable: true })
  //       this.getBucket(error)
  //       // utilityService.handleError(error)
  //     }
  //   )
  // }

  checkForFilterChange = (id, value) => {
    const { bucketItems } = this.props.bucketDetails
    const currentItem = bucketItems.find(item => item.id === id)
    if (currentItem) {
      let filterRule = currentItem.filterRule
      delete filterRule.__typename
      filterRule.filters = (filterRule.filters || []).map(item => {
        if (item.__typename) {
          delete item.__typename
        }
        return item
      })
      value.filters = value.filters.map(item => {
        if (item.__typename) {
          delete item.__typename
        }
        return item
      })
      return !_.isEqual(filterRule, value)
    } else return true
  }

  handleCancel = () => {
    this.setState({ visible: false })
  }

  onBucketEditClick = () => {
    this.setState({ visible: true })
  }

  editBucket = editRequest => {
    this.setState({ loading: true })
    editRequest.id = this.props.bucketId
    editRequest.updatedAt = new Date().toISOString()
    editRequest.updatedBy = this.username
    userSessionId = utilityService.makeRandomString(6)
    sessionStorage.setItem('user_session_id', userSessionId)
    this.props.updateBucket(editRequest).then(
      response => {
        this.props.updateHistory()
        let { bucketDetails } = this.state
        const responseData = response.data.updateBucket
        bucketDetails.name = responseData.name
        bucketDetails.displayType = responseData.displayType
        bucketDetails.displayName = responseData.displayName
        this.setState({
          loading: false,
          visible: false,
          bucketDetails
        })
      },
      error => {
        // this.setState({ loading: false })
        // utilityService.handleError(error)
        this.getBucket(error)
      }
    )
  }

  getBucket = error => {
    const { handleBucketDetailCellState, getSelectionDetailsForThisVersion, versionId } = this.props

    this.setState({ isModifiedLoading: true }, () => {
      this.props.fetchMoreBucketDetails().then(({ data }) => {
        if (error) {
          utilityService.handleError(error)
        }
        const { entitiesInsideVersions } = getSelectionDetailsForThisVersion(this.props.loadVersionBucketDetailsTolistData(_.cloneDeep(data.getBucket)), [], versionId)
        handleBucketDetailCellState({
          entitiesInsideVersions
        })
        this.setState({
          bucketDetails: _.cloneDeep(data.getBucket),
          // entities: this.props.loadVersionBucketDetailsTolistData(_.cloneDeep(data.getBucket)),
          isModifiedLoading: false,
          isWarningShow: false,
          isSaveEnable: false,
          loading: false,
          saveLoading: false
        })
      })
    })
  }

  refetchBucketData = () => {
    const { handleBucketDetailCellState, getSelectionDetailsForThisVersion, versionId } = this.props

    this.setState({ isModifiedLoading: true }, () => {
      // this.props.fetchMoreBucketDetails().then(({ data }) => {
      // if (error) { utilityService.handleError(error) }
      this.props.forceSaveCompleted(this.state.tempBucketDetails.id)
      const { entitiesInsideVersions } = getSelectionDetailsForThisVersion(this.props.loadVersionBucketDetailsTolistData(_.cloneDeep(this.state.tempBucketDetails)), [], versionId)
      handleBucketDetailCellState({
        entitiesInsideVersions
      })
      setTimeout(() => {
        this.setState({
          bucketDetails: _.cloneDeep(this.state.tempBucketDetails),
          // entities: this.props.loadVersionBucketDetailsTolistData(_.cloneDeep(this.state.tempBucketDetails)),
          isModifiedLoading: false,
          isWarningShow: false,
          isSaveEnable: false,
          loading: false,
          saveLoading: false,
          tempBucketDetails: null
        })
      }, 1000)
      // })
    })
  }

  // saveBucket = async (isAutoSave, isFromDelete) => {
  //   if (this.state.isSaveEnable) {
  //     this.props.onSave(this.props.bucketId)
  //     const { isUpdateBlocked } = this.props
  //     if (isUpdateBlocked) {
  //       return
  //     }
  //     this.setState({ saveLoading: true })
  //     // let isLatest = false
  //     // // await this.props.fetchBucketDetails().then(({ data }) => {
  //     // //   const { bucketDetails } = this.state
  //     // //   isLatest = moment(data.getBucket.updatedAt).isAfter(moment(bucketDetails.updatedAt), 'seconds')
  //     // // })
  //     // if (isLatest) {
  //     //   this.setState({ isWarningShow: true, saveLoading: false })
  //     // } else {
  //     const { bucketId } = this.props
  //     let { bucketItems } = this.state.bucketDetails
  //     userSessionId = utilityService.makeRandomString(6)
  //     sessionStorage.setItem('user_session_id', userSessionId)
  //     const assetList = (bucketItems || [])
  //       .filter(item => item.type === 'ASSET')
  //       .map(item => {
  //         const isImagePresent =
  //           !item.customAssetImage && item.customMedia
  //             ? (item.images || []).find(imageItem => imageItem.mediaId === item.customMedia.id)
  //             : null
  //         return {
  //           id: item.id,
  //           position: item.position,
  //           assetId: item.asset ? item.asset.id : null,
  //           type: item.type,
  //           customMedia: item.customAssetImage
  //             ? item.customAssetImage.mediaId
  //             : item.customMedia && isImagePresent
  //               ? item.customMedia.id
  //               : null,
  //           customAssetImage: item.customAssetImage ? item.customAssetImage.id : null,
  //           customTitle: item.customTitle,
  //           bucket: bucketId
  //         }
  //       })
  //     const filterList = (bucketItems || [])
  //       .filter(item => item.type === 'FILTER')
  //       .map(item => {
  //         return {
  //           bucket: bucketId,
  //           position: item.position,
  //           type: item.type,
  //           id: item.id,
  //           filterRule: {
  //             searchKey: item.filterRule.searchKey,
  //             filters: (item.filterRule && item.filterRule.filters && item.filterRule.filters.length
  //               ? item.filterRule.filters
  //               : []
  //             ).map(filterItem => {
  //               if (filterItem.type === 'KEYWORD' || filterItem.type === 'SELECT') {
  //                 if (typeof filterItem.value !== 'string') {
  //                   let value = (filterItem.value || []).map(filterInner => filterInner.key)
  //                   let key = (filterItem.value || []).map(filterInner => filterInner.name)
  //                   filterItem.value = value && value.length ? value.join() : null
  //                   filterItem.displayValue = key && key.length ? key.join() : null
  //                 }
  //               }
  //               if (filterItem.type === 'MULTIPLE' || filterItem.name === 'metaValue') {
  //                 if (typeof item.value === 'string' && item.value.startsWith('[')) {
  //                   filterItem.value = filterItem.value.slice(1, -1)
  //                 } else if (typeof filterItem.value !== 'string') {
  //                   filterItem.value =
  //                     filterItem.value && filterItem.value.length && filterItem.value.join(',')
  //                 }
  //               }
  //               delete filterItem.__typename
  //               return filterItem
  //             })
  //           }
  //         }
  //       })
  //     let bucketListItems = [...assetList, ...filterList]
  //     bucketListItems = bucketListItems && bucketListItems.length ? bucketListItems : null
  //     let bucketIdList =
  //       bucketListItems && bucketListItems.length ? bucketListItems.map(item => item.id) : null
  //     if (isFromDelete || !bucketListItems) {
  //       const variables = {
  //         id: bucketId,
  //         buckets: bucketIdList,
  //         updatedAt: new Date().toISOString(),
  //         updatedBy: this.username
  //       }
  //       const updatedBucketItems = this.getSortedList(
  //         _.cloneDeep(this.state.bucketDetails.bucketItems || [])
  //       )
  //       bucketListItems = (bucketListItems || []).map(bucketItem => {
  //         const itemIndex = updatedBucketItems.findIndex(item => item.id === bucketItem.id)
  //         if (itemIndex > -1) {
  //           bucketItem.position = itemIndex
  //         }
  //         return bucketItem
  //       })
  //       let updatedBucketListItems = _.cloneDeep(this.props.bucketDetails.bucketItems || [])
  //       bucketListItems = (bucketListItems || []).filter(item => {
  //         const tempIndex = updatedBucketListItems.findIndex(innerItem => innerItem.id === item.id)
  //         const isEdited = this.state.updatedBucketItem.indexOf(item.id) > -1
  //         return (
  //           isEdited ||
  //           tempIndex === -1 ||
  //           updatedBucketListItems[tempIndex].position !== item.position
  //         )
  //       })
  //       if (bucketListItems.length) {
  //         this.updatedBucketItemAndUpdateBucket(bucketListItems, variables, isAutoSave)
  //       } else {
  //         this.updateBucket(variables, isAutoSave)
  //       }
  //     } else {
  //       bucketListItems = bucketListItems && bucketListItems.length ? bucketListItems : null
  //       const variables = {
  //         id: bucketId,
  //         buckets: bucketIdList,
  //         updatedAt: new Date().toISOString(),
  //         updatedBy: this.username
  //       }
  //       bucketListItems = (bucketListItems || []).map(item => {
  //         const isAuditChange = this.changedBucketItem.includes(item.id)
  //         item.trackPosChange = isAuditChange
  //         return item
  //       })
  //       const updatedBucketItems = this.getSortedList(
  //         _.cloneDeep(this.state.bucketDetails.bucketItems)
  //       )
  //       bucketListItems = bucketListItems.map(bucketItem => {
  //         const itemIndex = updatedBucketItems.findIndex(item => item.id === bucketItem.id)
  //         if (itemIndex > -1) {
  //           bucketItem.position = itemIndex
  //         }
  //         return bucketItem
  //       })
  //       let updatedBucketListItems = _.cloneDeep(this.props.bucketDetails.bucketItems || [])
  //       bucketListItems = (bucketListItems || []).filter(item => {
  //         const tempIndex = updatedBucketListItems.findIndex(innerItem => innerItem.id === item.id)
  //         const isEdited = this.state.updatedBucketItem.indexOf(item.id) > -1
  //         return (
  //           isEdited ||
  //           tempIndex === -1 ||
  //           updatedBucketListItems[tempIndex].position !== item.position
  //         )
  //       })

  //       if (bucketListItems) {
  //         this.updatedBucketItemAndUpdateBucket(bucketListItems, variables, isAutoSave)
  //       } else {
  //         this.updateBucket(variables, isAutoSave)
  //       }
  //     }
  //     if (this.props.isForceSave) {
  //       this.props.forceSaveCompleted(this.props.bucketId)
  //     }
  //   }
  // }

  // updatedBucketItemAndUpdateBucket = (bucketListItems, variables, isAutoSave) => {
  //   const { bucketId } = this.props
  //   variables.bucketItems = variables.buckets
  //   delete variables.buckets
  //   // this.props.updateBucketItem(bucketListItems).then(() => {
  //   //   this.props.updateBucket(variables).then(({ data }) => {
  //   this.props
  //     .saveAllBuckets({ bucketItems: bucketListItems, bucket: variables, id: bucketId })
  //     .then(
  //       ({ data }) => {
  //         this.props.changeBucket(bucketId, false)
  //         this.changedBucketItem = []
  //         let copyOfResponse = cloneDeep(data.saveAllBuckets)
  //         const sortedData = this.getSortedList(cloneDeep(copyOfResponse?.bucketItems)) || []
  //         copyOfResponse = {
  //           ...copyOfResponse,
  //           bucketItems: sortedData
  //         }
  //         this.setState({ isSaveEnable: false, saveLoading: false, bucketDetails: copyOfResponse })
  //         if (!isAutoSave) {
  //           message.success(userMessages.BUCKET_UPDATED_SUCCESS)
  //         }
  //         this.props.updateHistory()
  //       },
  //       error => {
  //         // this.setState({ saveLoading: false })
  //         // utilityService.handleError(error)
  //         this.getBucket(error)
  //       }
  //     )
  //   // }, error => {
  //   //   // utilityService.handleError(error)
  //   //   this.getBucket(error)
  //   // })
  // }

  updateBucket = (variables, isAutoSave) => {
    const { bucketId } = this.props
    this.props.updateBucket(variables).then(
      ({ data }) => {
        this.props.changeBucket(bucketId, false)
        this.setState({
          isSaveEnable: false,
          saveLoading: false,
          updatedBucketItem: [],
          bucketDetails: data.updateBucket
        })
        if (!isAutoSave) {
          message.success(userMessages.BUCKET_UPDATED_SUCCESS)
        }
        this.props.updateHistory()
      },
      error => {
        // this.setState({ saveLoading: false })
        // utilityService.handleError(error)
        this.getBucket(error)
      }
    )
  }

  copyLink = () => {
    var anchor = document.createElement('a')
    anchor.href = `${location.origin}/buckets/preview/${this.props.bucketId}`
    anchor.target = '_blank'
    document.body.appendChild(anchor)
    anchor.click()
  }

  toggleDeleteeWarningMessage = status => {
    this.setState({ showWarning: status })
  }

  removeBucketItem = itemId => {
    const { bucketVersionItem, versionId } = this.props
    this.props.removeVersionBucketItem(itemId, bucketVersionItem, versionId)
  }

  onAssetTitleChange = (title, id) => {
    const { bucketVersionItem, onBucketVersionAssetTitleChange } = this.props
    onBucketVersionAssetTitleChange(title, id, bucketVersionItem)
  }

  onAssetDisplayImageChange = (media, id, defaultMedia) => {
    const { bucketVersionItem, onBucketVersionAssetDisplayImageChange } = this.props
    onBucketVersionAssetDisplayImageChange(media, id, defaultMedia, bucketVersionItem)
  }

  onAssetTitleReset = id => {
    const { bucketVersionItem, onBucketVersionAssetTitleReset } = this.props
    onBucketVersionAssetTitleReset(id, bucketVersionItem)
  }

  onAssetDisplayImageReset = id => {
    const { bucketVersionItem, onBucketVersionAssetDisplayImageReset } = this.props
    onBucketVersionAssetDisplayImageReset(id, bucketVersionItem)
  }

  onDragEnd = (startIndex, endIndex) => {
    let { listData } = this.state
    const [removed] = listData.splice(startIndex, 1)
    listData.splice(endIndex, 0, removed)
    this.setState({ listData })
  }

  getSortedList = data => {
    return (data || []).sort((a, b) =>
      a.position > b.position ? 1 : b.position > a.position ? -1 : 0
    )
  }

  showPublish = () => {
    this.setState({ showPublish: true })
  }

  handleCancel = () => {
    this.setState({ showPublish: false, visible: false })
  }

  onBucketScroll = () => {
    this.setState({ isScroll: false })
  }

  onMultiDrop = data => {
    let { bucketDetails } = this.state
    bucketDetails.bucketItems = data
    this.props.changeBucket(bucketDetails.id, true)
    this.setState({
      bucketDetails,
      isSaveEnable: true
    })
  }

  render () {
    const {
      isEditted,
      bucketDetails,
      visible,
      isSaveEnable,
      loading,
      showWarning,
      showPublish,
      saveLoading,
      // addFilterLoading,
      isScroll,
      isWarningShow,
      isModifiedLoading,
      tempBucketDetails
      // selectedTaskIds
    } = this.state
    const {
      versionId,
      // bucketId,
      deleteBucketGroupItem,
      selected,
      updateHistory,
      displayTypes,
      isCreateBlocked,
      isUpdateBlocked,
      isDeleteBlocked,
      draggingTaskId,
      isUpdateDisabledContent,
      isCreateDisabledContent,
      isDeleteDisabledContent,
      project,
      // bucketVersionHeader,
      showBucketVersions,
      droppableId,
      clearDragDropId,
      changeLoadingBucket,
      bucketGroupId,
      bucketItemsInVersion,
      droppableIdData,
      bucketVersionItem,
      isActive,
      handleBucketVersionModal,
      handleVersionDeletion,
      handleBucketVersionEnableDisable,
      isUpdateBucketVersionModalLoading,
      handleCopySchedule,
      onAddSearch,
      getActiveOrVersionDraggableId,
      onViewApiResponse,
      comparisonVersions,
      bucketVersionAPILoading,
      selectedTaskIdsInsideVersions,
      // entitiesInsideVersions,
      toggleSelectionOnVersions,
      toggleSelectionInGroupOnVersions,
      multiSelectToOnVersions
    } = this.props
    return (
      <>
        <div
          className={`bucket-detail-cell${selected ? ' selected' : ''} ${isActive ? 'bucket-detail-cell-active' : ''} bucket-version-detail-cell `}
          id={`bucket-detail-cell-${versionId}`}
        >
          {saveLoading ? <div className='overlay' /> : ''}
          <BucketVersionHeading
            versionName={bucketVersionItem.name}
            handleBucketVersionModal={handleBucketVersionModal}
            versionId={versionId}
            handleVersionDeletion={handleVersionDeletion}
            handleBucketVersionEnableDisable={handleBucketVersionEnableDisable}
            isEnabled={bucketVersionItem.isPublished}
            isSwitchLoading={isUpdateBucketVersionModalLoading}
            handleCopySchedule={handleCopySchedule}
            onAddSearch={onAddSearch}
            onViewApiResponse={onViewApiResponse}
          />
          <BucketDetailList
            listData={
              !isEmpty(bucketItemsInVersion)
                ? bucketItemsInVersion
                : []
            }
            isEditted={isEditted}
            onAddImage={this.onAddImage}
            onChangeFilter={(id, value) => this.props.onChangeFilter(id, value, bucketVersionItem)}
            onDragEnd={this.onDragEnd}
            handleAssetTitle={this.onAssetTitleChange}
            handleAssetTitleReset={this.onAssetTitleReset}
            handleAssetDisplayImageReset={this.onAssetDisplayImageReset}
            onAssetDisplayImageChange={this.onAssetDisplayImageChange}
            bucketId={versionId}
            removeBucketItem={this.removeBucketItem}
            parent={parent}
            isSaveEnable={isSaveEnable}
            saveLoading={saveLoading}
            parentCompoent={`bucket-detail-cell-${versionId}`}
            isScroll={isScroll}
            onBucketScroll={this.onBucketScroll}
            isUpdateBlocked={isUpdateBlocked}
            isCreateBlocked={isCreateBlocked}
            selectedTaskIds={selectedTaskIdsInsideVersions}
            toggleSelection={(taskId) => toggleSelectionOnVersions(taskId, versionId)}
            toggleSelectionInGroup={(taskId) => toggleSelectionInGroupOnVersions(taskId, versionId)}
            multiSelectTo={(newTaskId) => multiSelectToOnVersions(newTaskId, versionId)}
            draggingTaskId={draggingTaskId}
            project={project}
            isUpdateDisabledContent={isUpdateDisabledContent}
            isCreateDisabledContent={isCreateDisabledContent}
            isDeleteDisabledContent={isDeleteDisabledContent}
            bucketDetails={bucketDetails}
            bucketVersionList={bucketDetails?.versions}
            showBucketVersionList={showBucketVersions?.[versionId]}
            droppableId={droppableId}
            clearDragDropId={clearDragDropId}
            displayTypes={displayTypes}
            updateHistory={updateHistory}
            isDeleteBlocked={isDeleteBlocked}
            changeLoadingBucket={changeLoadingBucket}
            bucketGroupId={bucketGroupId}
            droppableIdData={droppableIdData}
            draggableIdIdentifier={getActiveOrVersionDraggableId(VERSION_DRAGGABLE_ID, versionId)}
            comparisonVersions={comparisonVersions}
            bucketVersionAPILoading={bucketVersionAPILoading}
          />

          <AddBucketModal
            visible={visible}
            handleCancel={this.handleCancel}
            createBucket={this.editBucket}
            bucketDetails={bucketDetails}
            isEdit
            loading={loading}
            displayTypes={displayTypes}
          />

          <ConfirmModal
            isVisible={showWarning}
            title={deleteWarningMessage.title}
            message={deleteWarningMessage.message}
            isLoading={false}
            rightButtonText={'Confirm'}
            handleCancel={() => this.toggleDeleteeWarningMessage(false)}
            handleSubmit={() => {
              deleteBucketGroupItem()
              this.toggleDeleteeWarningMessage(false)
            }}
          />

          <PublishBucketModal
            visible={showPublish && bucketDetails}
            handleCancel={this.handleCancel}
            bucketId={versionId}
            updateHistory={updateHistory}
            project={project}
          />

          <ConfirmModal
            isVisible={isWarningShow}
            title={'Warning'}
            message={
              tempBucketDetails
                ? `${tempBucketDetails.name} has been modified by ${tempBucketDetails.updatedBy}. Please refetch bucket details to get the latest updates`
                : ''
            }
            isLoading={isModifiedLoading}
            rightButtonText={'Refetch data'}
            handleSubmit={this.refetchBucketData}
            isSubmitButtonDisabled={false}
            isCancelButtonDisabled
            isCancelButtonInvisible
          />
        </div>
      </>
    )
  }
}

BucketDetailCellVersion.propTypes = {
  /** id of selected bucket. */
  id: PropTypes.string,
  /** Source index for bucket item drag and rearrange */
  sourceIndex: PropTypes.number,
  /** Destination index for bucket item drag and rearrange */
  destinationIndex: PropTypes.number,
  /** ID of newly added asset in buckets */
  droppableId: PropTypes.string,
  /** Id of buckets inwhich new asset added */
  draggable: PropTypes.object,
  /** Function to be called to clear drag and drop id */
  clearDragDropId: PropTypes.func,
  /** Function to be called to notify unsaved changes */
  changeBucket: PropTypes.func,
  /** Boolean for force save bucket */
  isForceSave: PropTypes.bool,
  /** Function to be called on complete of forced save of bucket */
  forceSaveCompleted: PropTypes.func,
  /** Boolean for disabling delete */
  isDeleteBlocked: PropTypes.bool,
  /** Boolean for disabling update */
  isUpdateBlocked: PropTypes.bool,
  /** Boolean for disabling create */
  isCreateBlocked: PropTypes.bool
}

export default withApollo(
  compose(
    // graphql(
    //   QueryGetBucketDetails,
    //   {
    //     skip: ({ bucketId }) => {
    //       return !bucketId
    //     },
    //     options: ({ bucketId }) => {
    //       return {
    //         variables: { id: bucketId }
    //       }
    //     },
    //     props: (properties) => {
    //       let bucketItems
    //       const props = cloneDeep(properties)
    //       if (props.data.getBucket) {
    //         bucketItems = props.data.getBucket.bucketItems
    //         bucketItems = (bucketItems || []).filter(item => item && (item.type !== 'ASSET' || item.asset)).sort((a, b) => (a.position > b.position) ? 1 : ((b.position > a.position) ? -1 : 0))
    //         props.data.getBucket.bucketItems = bucketItems
    //         props.data.getBucket.status = utilityService.getPublishStatus(props.data.getBucket.isPublished, props.data.getBucket.publishStartDate, props.data.getBucket.publishEndDate)
    //       }
    //       return {
    //         bucketDetails: _.cloneDeep(props.data.getBucket),
    //         isLoading: props.data.loading,
    //         fetchMoreBucketDetails: () => {
    //           return props.data.refetch()
    //         }
    //         // subscribeToChangeBucket: () => subscribeChangeInBucket(props.data.subscribeToMore, props)
    //       }
    //     }
    //   }
    // ),
    graphql(MutationCreateBucketItem, {
      options: props => ({
        // update: (cache, { data: { createBucket } }) => {
        //   const variables = { limit: 50 }
        //   const listCacheData = _.cloneDeep(cache.readQuery({ query: QueryFilterBuckets, variables }))
        //   if (listCacheData && listCacheData.listBuckets && listCacheData.listBuckets.items) {
        //     listCacheData.listBuckets.items.splice(0, 0, createBucket)
        //     listCacheData.listBuckets.totalCount++
        //   }
        //   cache.writeQuery({
        //     query: QueryFilterBuckets,
        //     data: listCacheData,
        //     variables
        //   })
        // }
      }),
      props: props => ({
        createBucketItem: bucketItemList => {
          let variables = bucketItemList
          variables.project = props.ownProps.project
          return props.mutate({
            variables
          })
        }
      }),
      withRef: true
    }),
    graphql(MutationUpdateBucket, {
      // options: ({ bucketId }) => ({
      //   update: (cache, { data: { updateBucket } }) => {
      //     const variables = { id: bucketId }
      //     const cachedData = _.cloneDeep(cache.readQuery({ query: QueryGetBucketDetails, variables }))
      //     if (cachedData && cachedData.getBucket) {
      //       cachedData.getBucket = updateBucket
      //     }
      //     cache.writeQuery({
      //       query: QueryGetBucketDetails,
      //       data: cachedData,
      //       variables
      //     })
      //   }
      // }),
      props: props => ({
        updateBucket: variables => {
          variables.project = props.ownProps.project
          return props.mutate({
            variables
          })
        }
      }),
      withRef: true
    }),
    // graphql(MutationSaveAllBuckets, {
    //   props: props => ({
    //     saveAllBuckets: variables => {
    //       variables.project = props.ownProps.project
    //       return props.mutate({
    //         variables
    //       })
    //     }
    //   }),
    //   withRef: true
    // }),
    graphql(MutationUpdateBucketItem, {
      options: props => ({}),
      props: props => ({
        updateBucketItem: bucketItems => {
          let variables = bucketItems
          variables.project = props.ownProps.project
          return props.mutate({
            variables
          })
        }
      }),
      withRef: true
    }),
    graphql(QueryGetBucketUpdatedDetails, {
      skip: ({ bucketId }) => {
        return !bucketId
      },
      options: ({ bucketId }) => {
        return {
          variables: { id: bucketId }
        }
      },
      props: props => {
        return {
          bucketUpdatedDetails: _.cloneDeep(props.data.getBucket),
          isLoading: props.data.loading,
          fetchBucketDetails: () => {
            return props.data.refetch()
          }
        }
      },
      withRef: true
    })
  )(BucketDetailCellVersion),
  { withRef: true }
)
